import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../config";
import { getTokenFromCookies } from "./users";

export const candidateApi = createApi({
  reducerPath: "candidateApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.apiUrl,
    prepareHeaders: async (headers) => {
      const token = await getTokenFromCookies();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getSuggestedKeywords: builder.query({
      query: ({ keyword }) => {
        
        return {
            url: keyword,
            method: "GET",
          }
      },
    }),
  }),
});

export const { useLazyGetSuggestedKeywordsQuery } = candidateApi;
